/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { GlobalMessageConfig, GlobalMessageType } from '@spartacus/core';

export const customGlobalMessageConfig: GlobalMessageConfig = {
  globalMessages: {
    [GlobalMessageType.MSG_TYPE_CONFIRMATION]: {
      timeout: 7000,
    },
    [GlobalMessageType.MSG_TYPE_INFO]: {
      timeout: 7000,
    },
    [GlobalMessageType.MSG_TYPE_ERROR]: {
      timeout: 7000,
    },
    [GlobalMessageType.MSG_TYPE_WARNING]: {
      timeout: 7000,
    },
    [GlobalMessageType.MSG_TYPE_ASSISTIVE]: {
      timeout: 7000,
    },
  },
};
